import React from 'react'
import {useSolv} from "../components/SolvProvider"
import MainMenu from "../MainMenu.js"
import {FormBody, FormHeader, MainContainer, useAlert} from "../components/FormComps.js"
import {useIntlEx} from "../components/IntlUtils"
import {DataTable, useCols} from "../components/TableComps"
import getLogger from "../components/Logging.js"
import '../App.css'
import {HumanTimestamp} from "../components/DateUtils";
import {StatusTagLabel} from "../components/TagBox";

const log = getLogger("SignupRequests")

export default function SignupRequest() {

  const {api, session: {user, tenant}, setBusy} = useSolv()
  const {intl } = useIntlEx()

  const [alert, setAlert] = useAlert(null)

  const {cols} = useCols({
    resourceName: "SignupRequests",
    specs: [
      {
        field: "createdOn",
        label: intl.msg("created"),
        filter: "select:reportDateRange",
        sort: "DESC",
        align: "left",
      },
      {
        field: "displayName",
        label: intl.msg("signup_request_applicant"),
        filter: "text",
        sort: "",
        align: "left",
      },
      {
        field: "status",
        label: intl.msg("status"),
        filter: {
          type: "select",
          options: () => {
            return ([
              {
                value: "APPEALED",
                label: intl.msg("status_appealed")
              },
              {
                value: "APPROVED",
                label: intl.msg("status_approved")
              },
              {
                value: "DECLINED",
                label: intl.msg("status_declined")
              },
              {
                value: "PENDING",
                label: intl.msg("status_pending")
              },
            ])
          },
          sort: "",
          align: "left",
        },
      },
    ],
  })

  function handleFetchDataPage({pageParam: cursor}) {
    return api.listSignupRequests({extraParams: cols.stringify(), cursor: cursor})
  }

  function handleRenderDataCol(col, row) {
    let n
    switch (col.field) {
      case "signupRequestId":
        n = <span>{row.signupRequestId}</span>
        break
      case "displayName":
        n = <span>{row.displayName}</span>
        break
      case "status":
        n = <StatusTagLabel status={row.status || "..."} size="lg"/>
        break
      case "createdOn":
        n = <HumanTimestamp timestamp={row.createdOn} else={intl.msg("never")}/>
        break
    }
    return (
        n
    )
  }

  function handleRowClick(row) {
    window.location = `/sys/signupRequests/${row.signupRequestId}`
  }

  function handleError(error) {
    if (error) {
      // log.debug("handleError: error=", JSON.stringify(error))
      if (error.code) {
        switch (error.code) {
          case "BAD_PAYLOAD":
            if (error.msg) {
              setAlert({type: "error", text: error.msg})
            }
            else {
              setAlert({type: "error", text: intl.msg("error_failed")})
            }
            break
          case "UNKNOWN_LOCATION":
            // log.debug("ERROR: ", error)
            if (error.msg) {
              setAlert({type: "error", text: error.msg})
            }
            else {
              setAlert({type: "error", text: intl.msg("error_failed")})
            }
            break
          default:
            setAlert({type: "error", text: intl.msg("error_failed")})
        }
      }
      else {
        setAlert({type: "error", text: intl.msg("error_failed")})
      }
    }
  }

  return (
    tenant &&
      <>

        <MainContainer tenant={tenant} menu={MainMenu} allowIfAccessingAs={"*/*/SYSTEM"}>

          <FormHeader>
            <FormHeader.Toolbar>
              <FormHeader.Toolbar.Title>
                {intl.msg("signup_requests")}
              </FormHeader.Toolbar.Title>
            </FormHeader.Toolbar>
            <FormHeader.Alert alert={alert}/>
          </FormHeader>
          <FormBody>
            <DataTable
              tenant={tenant}
                cols={cols}
                resourceName="signupRequest"
                dataKey="signupRequestId"
                onFetchDataPage={handleFetchDataPage}
                onRenderDataCol={handleRenderDataCol}
                onClickDataRow={handleRowClick}
            />
          </FormBody>
        </MainContainer>

      </>
  )
}